import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faBan,
  faCheck,
  faDoorOpen,
  faShower,
  faTshirt,
} from "@fortawesome/free-solid-svg-icons";
import { dateTimeFormatterWithDay } from "../../global";

export const DriveInIcon = faAngleDoubleLeft;
export const DriveOutIcon = faAngleDoubleRight;
export const DeniedIcon = faBan;
export const GrantedIcon = faCheck;

const directionIconProps = {
  drive_in: { icon: DriveInIcon, className: "fa-fw mr-2 text-success" },
  drive_out: { icon: DriveOutIcon, className: "fa-fw mr-2 text-danger" },
  door: { icon: faDoorOpen, className: "fa-fw mr-2 text-success" },
  shower: { icon: faShower, className: "fa-fw mr-2 text-success" },
  wash_machine: { icon: faTshirt, className: "fa-fw mr-2 text-success" },
};

const GateLogRow = ({ gateLog }) => {
  const directionIcon = directionIconProps[gateLog.direction];

  return (
    <tr>
      <td className="p-3">
        {gateLog.access_status === "granted" ? (
          <FontAwesomeIcon
            className="fa-fw mr-2 text-success"
            icon={GrantedIcon}
          />
        ) : (
          <FontAwesomeIcon
            className="fa-fw mr-2 text-danger"
            icon={DeniedIcon}
          />
        )}
        {directionIcon && (
          <FontAwesomeIcon
            className={directionIcon.className}
            icon={directionIcon.icon}
          />
        )}
        {gateLog.access_system?.name}
      </td>
      <td>{gateLog?.card_holder}</td>
      <td> {dateTimeFormatterWithDay(gateLog.created_at)} </td>
      <td>{gateLog.nfc_card_uid}</td>
    </tr>
  );
};

export default GateLogRow;
